import { getViewDefintionFromObject } from '../../../components/factories/AttributeDefinitions';
/** Used in ObjectDetailCard via Listerlizer where new objects have required fields that are normally not editable  */
export const getViewDefinitionForNewObject = (newObject) => {
    let newObjectViewDefinition = undefined;
    if (newObject) {
        newObjectViewDefinition = getViewDefintionFromObject(newObject);
        if (newObjectViewDefinition) {
            /** finally remove all attributes which cant be edited */
            Object.entries(newObjectViewDefinition).forEach(([k, vkd]) => {
                if (vkd.editable === false) {
                    delete newObjectViewDefinition[k];
                }
            });
        }
    }
    return newObjectViewDefinition;
};
